import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/@babel/runtime/regenerator/index.js";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { useRouter } from "next/router";
import { DPBox, DPText } from "@dp/system";
var ReservationsComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.Reservations;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var SpreedlyPaymentModal = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.SpreedlyPaymentModal;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var ReservationsPage = function ReservationsPage() {
  var _router$query, _store$reservation2, _store$reservation3;
  var store = useStore();
  var router = useRouter();
  var confirmationNumber = router.query.confirmationNumber;
  var reservationDate = router.query.reservationDate;
  var seatingOption = router.query.seatingOption;
  var action = router.query.action;
  var restaurantNumber = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.setRestaurant;
  var _useRouter = useRouter(),
    query = _useRouter.query;
  var isMyReservationsTabActive = (query === null || query === void 0 ? void 0 : query.tab) === "my-reservations";
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isStoreInitialized = _React$useState2[0],
    setIsStoreInitialized = _React$useState2[1];
  useEffect(function () {
    var isMounted = true;
    var initStore = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _store$reservation;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return store.initComponent("Reservations");
            case 3:
              if (isMounted) {
                if (isMyReservationsTabActive && (_store$reservation = store.reservation) !== null && _store$reservation !== void 0 && _store$reservation.reservationModel) {
                  store.reservation.reservationModel.tabReserveTable = false;
                }
                setIsStoreInitialized(true);
              }
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error("Failed to initialize reservations store:", _context.t0);
              if (isMounted) {
                setIsStoreInitialized(true);
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function initStore() {
        return _ref.apply(this, arguments);
      };
    }();
    initStore();
    return function () {
      isMounted = false;
    };
  }, []);
  if (!isStoreInitialized) {
    return null;
  }
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.reservations.pagetitle", {
    defaultValue: "Restaurant Reservations"
  }))), __jsx(ReservationsComp, {
    confirmationNumber: confirmationNumber,
    action: action,
    reservationDate: reservationDate,
    restaurantNumber: restaurantNumber,
    seatingOption: seatingOption
  }), ((_store$reservation2 = store.reservation) === null || _store$reservation2 === void 0 || (_store$reservation2 = _store$reservation2.reservationModel) === null || _store$reservation2 === void 0 ? void 0 : _store$reservation2.spreedlyLoading) && __jsx(DPBox, {
    position: "fixed",
    inset: 0,
    bg: "rgba(0,0,0,0.4)",
    zIndex: 9998,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, __jsx(DPBox, {
    bg: "white",
    borderRadius: 8,
    py: 6,
    px: 8
  }, __jsx(DPText, {
    fontSize: 14,
    color: "gray.800"
  }, "Securing reservation\u2026"))), ((_store$reservation3 = store.reservation) === null || _store$reservation3 === void 0 ? void 0 : _store$reservation3.reservationModel.isSpreedlyDataLoaded) && __jsx(SpreedlyPaymentModal, null));
};
ReservationsPage.layout = PageLayout.NB_LAYOUT;
ReservationsPage.layoutProps = {
  showJoinWaitListHeader: true
};
export default observer(ReservationsPage);